import AppRouter from "./routing/AppRouter";
import { QueryClientProvider } from "@tanstack/react-query";
import { ThemeContextProvider } from "./contexts/ThemeContext";
import queryClient from "./services/queryClient";
import { ErrorProvider, useError } from "./contexts/ErrorContext";
import { registerErrorHandler } from "./services/errorHandler";
import GlobalErrorSnackbar from "./components/common/GlobalErrorSnackbar";
import { AuthProvider } from "./contexts/AuthContext";

function ErrorHandlerRegistrar() {
	const { showError } = useError();
	registerErrorHandler(showError);
	return null;
}

function App() {
	return (
		<ThemeContextProvider>
			<QueryClientProvider client={queryClient}>
				<ErrorProvider>
					<ErrorHandlerRegistrar />
					<AuthProvider>
						<AppRouter />
					</AuthProvider>
					<GlobalErrorSnackbar />
				</ErrorProvider>
			</QueryClientProvider>
		</ThemeContextProvider>
	);
}

export default App;
